<template>
  <div id="contact" class="section_Bot">
    <contact-proyect v-if="proyect" :selection="now" @cancel="selected = ''" @gratitude="thanks"></contact-proyect>
    <contact-form v-if="now=='coment'" @cancel="selected = ''" @gratitude="thanks"></contact-form>
    <div v-if="now==''" class="content-page">
      <div class="px-5 pt-3 sectionTop">
        <p class="title pt-sm-4 text-center text-lg-left" v-html="$t('contact.content.findUsIn')"/>
        <div class="py-1 d-flex flex-row align-items-center justify-content-center container-fluid" style="gap: 2rem">
          <a v-for="d in directories" :href="d.url" target="_blank">
            <img :src="d.image" :alt="d.alt" class="dir-image"/>
          </a>

        </div>
        <p class="title pt-sm-4 text-center text-lg-left" v-html="$t('contact.content.header')"/>
        <p class="py-3 text px-0 pl-lg-5 space  text-center text-lg-left" v-html="$t('contact.content.headerDescription')"/>
        <div class="d-block d-md-block d-lg-none pt-3">
          <div class="col-12 centerAligh pb-5 mb-5 d-flex flex-column justify-content-center flex-sm-row">
<!--            <div class="px-3">-->
<!--              <p class="title" v-html="$t('contact.content.direction')"/>-->
<!--              <p class="text centerAligh">Bolívar - Venezuela </p>-->
<!--            </div>-->

            <div class="px-3 mb-4 mb-sm-5">
              <p class="title mb-0 mb-sm-4" v-html="$t('contact.content.phone')"/>
              <a href="https://api.whatsapp.com/send?phone=+584128750347" target="_blank" class="d-block w-100 ws-link">+58 412 8750347</a>
<!--              <p class="text centerAligh">+58 286 - 961.58.99 </p>-->
<!--              <p class="text centerAligh">+58 286 - 961.32.85</p>-->
<!--              <p class="text centerAligh">+58 286 - 971.95.09</p>-->
            </div>

            <div class="px-3 mb-4 mb-sm-5">
              <p class="title mb-0 mb-sm-4" v-html="$t('contact.content.mail')"/>
              <a href="mailto:info@grupoapok.com"  target="_blank" class="text text-center mb-0 to-email">info@grupoapok.com</a>
            </div>

          </div>

        </div>
      </div>

      <div class="sectionMid d-flex flex-row justify-content-center">
        <div class="col-3 py-md-2 py-lg-3 d-none d-md-block">
          <img class="px-5 py-2" src="../assets/images/contact/messages.png" alt="messages"/>
        </div>

        <b-col class="py-5 pl-4 d-none d-md-block">
          <p class="midSection linea1 pl-5">
            <strong class="linea1">{{'contact.content.bodyFrase' | translate}}</strong><br/>
            <strong class="text">{{'contact.content.bodyFrase1' | translate}}</strong>
          </p>
        </b-col>
      </div>


      <div class="px-5 section_Bot col-sm-12 talk">
        <p class=" px-3 text textConver text-center text-md-left" v-html="$t('contact.content.aboutFrase')"/>
        <div class="d-flex flex-row justify-content-center pb-3">
<!--          <select class="border-class px-5" v-model="selected">-->
<!--            <option disabled value="" v-html="$t('contact.content.selector')"></option>-->
<!--            <option v-for="text in $t('contact.content.opciones')">{{ text }}</option>-->
<!--          </select>-->
          <b-form-select class="border-class px-5" v-model="selected">
            <option disabled value="" v-html="$t('contact.content.selector')"></option>
            <option v-for="(text, i) in $t('contact.content.opciones')" :key="i" :value="text">{{ text }}</option>
          </b-form-select>
        </div>
      </div>
    </div>
<!--    <Footer class=""></Footer>-->
  </div>

</template>

<script>
  import LayoutContent from '../components/layouts/LayoutContent'
  import ContactForm from '../pages/ContactForm.vue'
  import Footer from '../components/Footer.vue'
  import ContactProyect from '../pages/ContactProyect.vue'
  import GoodFirmsLogo from '../assets/images/GF-Blue-1.png'
  import DesignRushLogo from '../assets/images/design_rush_tcsdc.png'

  export default {
    name: 'Contact',
    components: {LayoutContent, ContactForm, Footer, ContactProyect},
    data () {
      return {
        seeForm: '',
        selected: '',
        proyect: false,
        directories: [
          {
            url: 'https://www.goodfirms.co/',
            alt: 'GoodFirms',
            image: GoodFirmsLogo,
          },
          {
            url: 'https://www.designrush.com',
            alt: 'DESIGNRUSH',
            image: DesignRushLogo,
          }
        ]
      }
    },
    methods: {
      thanks () {
        this.$emit('contactChange', '')
      }
    },
    computed: {
      now: function () {
        this.seeForm = ''
        this.proyect = false
        if (this.selected === this.$t('contact.content.opciones')[3]) {
          this.seeForm = 'coment'
        }
        if (this.selected === this.$t('contact.content.opciones')[0]) {
          this.seeForm = 'web'
          this.proyect = true
        }
        if (this.selected === this.$t('contact.content.opciones')[1]) {
          this.seeForm = 'app'
          this.proyect = true
        }
        if (this.selected === this.$t('contact.content.opciones')[2]) {
          this.seeForm = 'dise'
          this.proyect = true
        }
        return this.seeForm
      }
    },
    mounted () {
      this.$emit('pageShowing', 3)
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/contact';

  .ws-link, .to-email {
    color: #EC8409 !important;
    font-weight: 700;

    position: relative;

    &:after {
      /*content: "";*/
      background-color: #fff;
      height: 1px;
      width: 30px;
      position: absolute;
      bottom: -3px;
      left: 50%;
      transform: translateX(-50%);

    }
    &:hover {
      cursor: pointer;
      color: #1D8DA1 !important;
      text-decoration: none;
      text-shadow: none;
      font-weight: 700;

      &:after {
        background-color: #1D8DA1;
      }

    }
  }

  #contact {
    height: 100vh;
    position: relative;
  }

  .sectionTop {
    background-color: #FFFFFF;
    /*@media (min-width: 1400px) {
      min-height: 28vh;
    }*/
  }

  .centerAligh {
    text-align: center;
  }

  .section_Bot {
    background-color: #60BDC5;
    // padding-bottom: 10%;
  }

  .sectionMid {
    background-color: #EFF7FB;

  }

  .space {
    padding-right: 100px;
  }

  .border-class {
    background-color: #EFF7FB;
    width: calc(40rem + 10px);
    height: calc(3rem + 10px);
    color: #60BDC5;
    border: 2px solid;
    font-size: 1.3rem;
    // padding: 10px;
    border-radius: 10px;
    font-weight: bold;
  }

  .dir-image {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue